import SearchOutlined from '@mui/icons-material/SearchOutlined';
import { InputAdornment, TextField } from '@mui/material';
import { useRef } from 'react';
import { useSearchParam } from '../search.hooks';

export type SearchInputProps = {
  InputProps?: object;
  searchParam: string;
  placeholder?: string;
};

const SearchInput = ({
  InputProps = {},
  searchParam,
  ...rest
}: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>();

  const { value, setValue } = useSearchParam(searchParam);

  return (
    <TextField
      defaultValue={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined />
          </InputAdornment>
        ),
        ...InputProps,
      }}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          setValue(inputRef.current.value);
        }
      }}
      inputRef={inputRef}
      data-testid="SearchInput"
      sx={{
        '&&': {
          m: 0,
        },
      }}
      {...rest}
    />
  );
};

export default SearchInput;
